import { createGradientOrSolid } from '../components/Helper/utils/utils';
import { StoreThemeResponse } from './types';
import { BannerAspectRatio } from '../components/Popups/types';
import { useEffect, useState } from 'react';
import { ESalePercentageDisplayType } from '../components/Helper/enums';

export function useSetCssVars(
    storeTheme: StoreThemeResponse,
    document: Document
): void {
    if (!storeTheme) return;
    const generalTheme = storeTheme.general;
    const storeScreenTheme = storeTheme.storeScreen;
    const defaultMap = {
        '--font-family': generalTheme?.font,
        '--button-text-color': generalTheme?.buttonTextColor,
        '--button-bg-color': createGradientOrSolid(generalTheme?.buttonColor),
        '--bundle-border-color': createGradientOrSolid(
            storeScreenTheme.bundleBorderColor
        ),
        '--popup-banner-ratio':
            generalTheme?.popupRatio || BannerAspectRatio.SQUARE
    };
    overrideCssVars(defaultMap, document);
}

export function overrideCssVars(
    cssToValuesMap: Record<string, any>,
    document: Document
): void {
    const styleElement = document.createElement('style');
    let styles = 'body { ';

    Object.entries(cssToValuesMap).forEach(([key, value]) => {
        styles += `${key}: ${value}; `;
    });

    styles += '}';
    styleElement.textContent = styles;

    document.head.appendChild(styleElement);
}

export function useIsDesktop() {
    const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);

    useEffect(() => {
        const updateIsDesktop = () => {
            setIsDesktop(window.innerWidth >= 1024);
        };

        updateIsDesktop();
        window.addEventListener('resize', updateIsDesktop);
        return () => {
            window.removeEventListener('resize', updateIsDesktop);
        };
    }, []);

    return isDesktop;
}

export function useIsLandscape() {
    const [isLandscapeMobile, setIsLandscapeMobile] = useState(
        window.innerWidth >= 1024
    );

    useEffect(() => {
        const updateIsLandscape = () => {
            const width = window.innerWidth;
            const height = window.innerHeight;
            setIsLandscapeMobile(height <= 500 && width > height);
        };

        updateIsLandscape();
        window.addEventListener('resize', updateIsLandscape);
        return () => {
            window.removeEventListener('resize', updateIsLandscape);
        };
    }, []);

    return isLandscapeMobile;
}

export const generateSalePercentageBasedOnType = (
    salePercentage: number,
    salePercentageDisplayType?: ESalePercentageDisplayType
) => {
    switch (salePercentageDisplayType) {
        case ESalePercentageDisplayType.MULTIPLIER:
            return `${salePercentage}x`;
        case ESalePercentageDisplayType.FIXED_AMOUNT:
            return `+${salePercentage}`;
        default:
            return `${salePercentage}%`;
    }
};
